import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { handleRedeemCoupon } from '../../common/subscription/SubscriptionService';
import {
  Stack,
  Typography,
  CircularProgress,
  TextField,
  Box,
  Button,
} from '@mui/material';
import { showSuccessSnackbar } from '../../common/snackbar/SnackbarActions';
import CancelIcon from '@mui/icons-material/Cancel';
import PlusIcon from '@mui/icons-material/AddCircleOutline';

const validationSchema = Yup.object().shape({
  couponCode: Yup.string().required('Required').nullable(),
});

export default function RedeemCouponForm({ callback = () => {} }) {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <Formik
      initialValues={{
        couponCode: null,
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await handleRedeemCoupon(values.couponCode)
          .then((res) => {
            if (res) {
              showSuccessSnackbar('Coupon Redeemed');
              callback();
            } else {
              const errMsg =
                'There was an issue redeeming the coupon, if the problem persists please contact us.';
              console.error(errMsg);
              setErrorMessage(errMsg);
            }
            setSubmitting(false);
          })
          .catch((err) => {
            let errMsg =
              'An error has occurred, if it persists please contact us'; //Default message
            if (err.response !== undefined) {
              errMsg = err.response.data['Error']
                ? err.response.data['Error']
                : err.response.data['ValidationError']
                ? 'The coupon code provided is not valid'
                : 'An error has occurred, if it persists please contact us';
            } else if (err.message !== undefined) {
              errMsg = err.message;
            }
            console.error(err);
            console.error(errMsg);
            setErrorMessage(errMsg);
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting,
      }) => {
        return (
          <Form>
            <Stack alignItems='center' justifyContent='center'>
              <Typography sx={{ textAlign: 'left' }}>
                To redeem a coupon please enter the coupon code below and click
                apply.
              </Typography>
              <TextField
                name='couponCode'
                type='text'
                label='Coupon Code'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.couponCode}
                placeholder='Coupon Code'
                variant='standard'
                error={errors.couponCode && touched.couponCode}
                helperText={touched.couponCode && errors.couponCode}
                sx={{ m: 1, width: '20vw', minWidth: '35ch', maxLength: 64 }}
              />
              {errorMessage && (
                <Typography sx={{ color: 'error.main' }}>
                  {errorMessage}
                </Typography>
              )}
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  type={'submit'}
                  disabled={isSubmitting}
                  variant='contained'
                >
                  <PlusIcon style={{ marginRight: '5' }} />
                  Apply
                </Button>
                {isSubmitting && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'secondary.main',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-9px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
              <Button
                type={'reset'}
                color='secondary'
                disabled={isSubmitting}
                variant='contained'
                onClick={callback}
              >
                <CancelIcon style={{ marginRight: '5' }} />
                Cancel
              </Button>
            </Stack>
          </Form>
        );
      }}
    </Formik>
  );
}
